import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import {
  ActivatedRoute,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';
import { EventService } from './Data-service/event.service';
import { RoutingState } from './services/routing-state.service';
import { DOCUMENT, PlatformLocation } from '@angular/common';
import { ConnectionService } from 'ng-connection-service';
import { interval, Observable } from 'rxjs';
import { OnInit } from '@angular/core/src/metadata/*';
import { SettingsService } from './component/protect-component/AdviserComponent/setting/settings.service';
import { AuthService } from './auth-service/authService';
import { EnumDataService } from './services/enum-data.service';
import { LoginService } from './component/no-protected/login/login.service';
import { filter } from 'rxjs/operators';
import { WebSocketService } from './web-socket.service';
// declare let Chatbot: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  @ViewChild('mainrouter', {
    static: true
  }) mainrouter;
  isConnected = true;
  onlineStatus: boolean;
  timeLeft: any;
  intervalTimer: any;
  showTimeRemaining: number;
  setNewTime: any;
  showCallPopup!: Observable<boolean>;
  isAdvisorLogin: boolean = false;



  ngOnInit() {
    const currentDomain = window.location.hostname;
    console.log(currentDomain, "CURRENT DOMAINNNN ");

    if (currentDomain === 'support.ifanow.in') {
      console.log("--------------------call for a connection-----------------------");
      this.wsSErvice.connect();
    }

    this.showCallPopup = this.enumDataService.advisorPopup$;
    console.log(this.showCallPopup, "SHOWW");


    this.authService.isAdvisorLogin$.subscribe((res: boolean) => {
      this.isAdvisorLogin = res;
    })

    let width, height;
    // initializeChatbot()
    width = document.documentElement.clientWidth;
    height = document.documentElement.clientHeight;
    // if (height > width) {
    //   this.document.getElementById('tabviewJs').style.width = `${height}px`
    //   this.document.getElementById('tabviewJs').style.height = `${width}px`;

    // }
    console.log('document.location.hostname : ', document.location.hostname);
    console.log('window.location.hostname : ', window.location.hostname);

    AuthService.hostName = document.location.hostname;
    // AuthService.hostName = 'manekfinancial.com';
    //this.getDomainData(AuthService.hostName);
    const domainData = {
      faviconUrl: 'https://www.google.com/favicon.ico',
      appTitle: 'This is a tribute'
    };
    // this.setValuesAsPerDomain(domainData);
  }

  getDomainData(data) {
    // data = 'clients.manekfinancial.com';
    const obj = {
      hostName: data
    };
    console.log('this.obj : ', JSON.stringify(obj));
    this.settingService.getDomainData(obj).subscribe(res => {
      if (res) {
        console.log('this.res : ', JSON.stringify(res));
        res.hostName = data;
        AuthService.setDomainDetails(res);
        this.setValuesAsPerDomain(res);
      }
    },
      err => {
        console.log(err);
      });
  }

  setValuesAsPerDomain(data) {
    this.document.getElementById('appAppleTouchIcon').setAttribute('href', data.feviconUrl);
    this.document.getElementById('appIcon32').setAttribute('href', data.feviconUrl);
    this.document.getElementById('appIcon').setAttribute('href', data.feviconUrl);
    // console.log('titleElement', this.document.getElementById('appTitle'));
    this.document.title = data.siteTitle;
    // this.document.getElementById('appTitle').setAttribute('title', data.appTitle);

    // appTitle
  }

  ngAfterViewInit(): void {
    this.routingState.setMainRouter(this.mainrouter);

  }

  constructor(
    private lBar: SlimLoadingBarService,
    private wsSErvice: WebSocketService,
    private _router: Router, private eventService: EventService,
    private routingState: RoutingState,
    private location: PlatformLocation,
    private authService: AuthService,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private connectionService: ConnectionService,
    private settingService: SettingsService,
    public enumDataService: EnumDataService,
    @Inject(DOCUMENT) private document
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // if (event.url.includes('login')) {
      //   Chatbot.destroy();
      // } else {
      //   // initializeChatbot()
      // }
    });

    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.onlineStatus = true;
        this.showTimeRemaining = 5;
        this.intervalTimer.unsubscribe();
      } else {
        this.onlineStatus = false;
        this.countDown(5);
      }
    });
    // routingState.changeDetector = changeDetector;
    routingState.router = _router;
    routingState.loadRouting();
    this._router.events.subscribe((event: Event) => {
      this.loadingBarInterceptor(event);
    });
    console.log('document.location', document.location);
    console.log('document : ', document);
    // document.location.host
  }

  countDown(timer) {
    this.timeLeft = timer;
    this.setNewTime = timer;
    this.intervalTimer = interval(1000).subscribe(
      data => {
        if (this.timeLeft == 0) {
          timer = 2 * timer;
          this.timeLeft = 2 * timer;
        } else {
          this.showTimeRemaining = this.timeLeft--;
        }
      }
    );
  }

  private loadingBarInterceptor(event: Event) {
    if (event instanceof NavigationStart) {
      this.lBar.start();
    }
    if (event instanceof NavigationEnd) {
      this.lBar.complete();
    } else if (event instanceof NavigationCancel) {
      this.lBar.complete();
    } else if (event instanceof NavigationError) {
      this.lBar.complete();
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

}
// Function to initialize the chatbot
// function initializeChatbot() {
//   Chatbot.init({
//     chatflowid: "0cb7f8c4-b13f-46e8-8c94-bce450a728d9",
//     apiHost: "https://ai.ifanow.in",
//     chatflowConfig: {
//       // topK: 2
//     },
//     theme: {
//       button: {
//         backgroundColor: "#176EFF",
//         right: 20,
//         bottom: 20,
//         size: "medium",
//         iconColor: "white",
//         customIconSrc: "https://raw.githubusercontent.com/walkxcode/dashboard-icons/main/svg/google-messages.svg",
//       },
//       chatWindow: {
//         welcomeMessage: "Hey, Ask me anything! IFANOW Rocks!!!",
//         backgroundColor: "#FFFFFF",
//         height: 500,
//         width: 400,
//         fontSize: 16,
//         poweredByTextColor: "#303235",
//         botMessage: {
//           backgroundColor: "#50EC92",
//           textColor: "#0A0A0A",
//           showAvatar: true,
//           avatarSrc: "https://res.cloudinary.com/futurewise/image/upload/v1680095076/myplanner/IFANOW_Square_logo_1.png",
//         },
//         userMessage: {
//           backgroundColor: "#3B81F6",
//           textColor: "#FFFFFF",
//           showAvatar: true,
//           avatarSrc: "https://raw.githubusercontent.com/zahidkhawaja/langchain-chat-nextjs/main/public/usericon.png",
//         },
//         textInput: {
//           placeholder: "Ask me anything!",
//           backgroundColor: "#FFFFFF",
//           textColor: "#303235",
//           sendButtonColor: "#3B81F6",
//         }
//       }
//     }
//   });
// }

